import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Home from "./pages/home";
import AboutMe from "pages/about-me";
import ContactMe from "pages/contact-me";
import Live from "pages/live";
import Tv from "pages/tv";
import VoiceEchoStudio from "pages/echo-studio";
import DJStudio from "pages/dj-studio";
import NotificationBar from "components/NotificationBar";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <NotificationBar />
        <RouterRoutes>
          <Route path="/" element={<Home />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/contact-me" element={<ContactMe />} />
          <Route path="/live" element={<Live />} />
          <Route path="/tv" element={<Tv />} />
          <Route path="/echo-studio" element={<VoiceEchoStudio />} />
          <Route path="/dj-studio" element={<DJStudio />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
